import { useTranslation } from "react-i18next";

interface SubscribeButtonProps {
  loading: boolean;
  disabled: boolean;
  onClick: () => void;
  isGift?: boolean;
  className?: string;
  fixed?: boolean;
  paymentType?: 'one_time' | 'subscription';
}

export const SubscribeButton = ({
  loading,
  disabled,
  onClick,
  isGift = false,
  className = '',
  fixed = true,
  paymentType = 'one_time'
}: SubscribeButtonProps) => {
  const { t } = useTranslation();
  
  const getButtonText = () => {
    if (loading) return null;
    
    if (isGift) return t('subscription.subscribeButton.sendGift');
    
    if (paymentType === 'subscription') {
      return t('subscription.subscribeButton.subscribe');
    }
    
    return t('subscription.subscribeButton.placeOrder');
  };
  
  // Simplified container class - just use fixed when requested
  const containerClass = fixed 
    ? 'fixed bottom-0 left-0 right-0 w-full bg-white py-3 px-4 border-t border-gray-100 shadow-lg z-40'
    : '';
  
  return (
    <div className={`${containerClass} ${className || ''}`}>
      <div className={`${fixed ? 'max-w-md mx-auto' : ''}`}>
        <button
          onClick={onClick}
          disabled={loading || disabled}
          className={`w-full h-[60px] rounded-[16px] font-medium text-black bg-[#F9D348] 
          hover:bg-[#f7cb26] active:bg-[#f4c40c] transition-colors duration-200
          disabled:bg-[#FDEDB6] disabled:cursor-not-allowed`}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-black mr-2"></div>
              Processing...
            </div>
          ) : (
            getButtonText()
          )}
        </button>
      </div>
    </div>
  );
};

export default SubscribeButton; 